import {
  buildHeader,
  buildParagraph,
  buildTextRun,
  renderElementToImageRunById,
  createTableHeaderCell,
  createTableCell,
  buildNewlines,
  buildHyperlink,
} from "./helpers";
import { AlignmentType, TableRow, Table, ShadingType } from "docx";

const readingPlanTableData = require("./mock/readingPlanTable.json");

const createSectionReadingPlan = async (
  studentData,
  weeklyPlan,
  readingRopeReportId
) => [
  // Individual Reading Plan
  buildHeader(`${studentData.firstName}'s Individual Reading Plan`, 3, true),
  // Rope Graphic
  buildParagraph(
    "[TODO] [Placeholder: Rope Graphic] [Works when data is available, uncomment needed blocks in IRIPDocumentGenerator.js to generate, use following code:]"
  ),
  buildParagraph("await renderElementToImageRunById(readingRopeReportId"),
  ...buildNewlines(2),
  // Science of Reading Macro Profile
  buildTextRun([
    {
      text: "Science of Reading Macro Profile: ",
      bold: true,
    },
    {
      text: "[TODO] [Mock: Maria needs to work on ",
      italics: true,
    },
    {
      text: "vocabulary ",
      bold: true,
    },
    {
      text: "and ",
    },
    {
      text: "fluency.]",
      bold: true,
    },
  ]),
  ...buildNewlines(1),
  // Science of Reading Macro Profile Explanation
  buildTextRun([
    {
      text: "[TODO] [Mock: Maria continues to progress at a rate greater than average. Her needs are focused on ",
    },
    {
      text: "building vocabulary ",
      bold: true,
    },
    {
      text: "and ",
    },
    {
      text: "spending more time on text",
      bold: true,
    },
    {
      text: ". A critical element of her plan is ensuring she works with me at least 30 minutes a week.]",
    },
  ]),
  ...buildNewlines(2),
  // Individual Reading Plan Table
  createIndividualReadingPlanTable(readingPlanTableData),
  ...buildNewlines(2),
  // EL Researching to Build Knowledge and Teach Others: {TODO: Get Next Module} Readiness Profile
  buildHeader(
    `EL Researching to Build Knowledge and Teach Others: [TODO] Mock: 3 Readiness Profile`,
    3
  ),
  // EL Researching to Build Knowledge and Teach Others: {TODO: Get Next Module} Readiness Profile Summary
  buildParagraph(
    `[TODO] [Mock: As EL turns to the next unit on Pollinators, Maria will need scaffolding in this area.]`
  ),
  buildHyperlink(
    `Here’s a link to the Lesson Planner, where you can assign them the right work. [TODO] [put correct link to lesson planner]`,
    "https://www.google.com"
  ),
  ...buildNewlines(2),
];

const createIndividualReadingPlanTable = (tableData) => {
  const rows = [];
  rows.push(
    new TableRow({
      children: tableData.headers.map((header) =>
        createTableHeaderCell(header.text)
      ),
    })
  );
  tableData.rows.forEach((row, rowIndex) => {
    rows.push(
      new TableRow({
        children: tableData.headers.map((header, colIndex) => {
          // Set the first cell background color to #0E9ED5
          if (colIndex === 0) {
            return createTableCell({
              text: row[header.key],
              shadingColor: "0E9ED5",
              shadingType: ShadingType.CLEAR,
              fontColor: "FFFFFF",
            });
          }
          // Alternate the color of the remaining cells between #95DCF7 and #CCCCCC
          const color = rowIndex % 2 === 0 ? "95DCF7" : "CCCCCC";
          return createTableCell({
            text: row[header.key],
            shadingColor: color,
            shadingType: ShadingType.CLEAR,
            bold: true,
          });
        }),
      })
    );
  });
  return new Table({
    columnWidths: tableData.headers.map(() => 9000 / tableData.headers.length),
    rows: rows,
  });
};

export default createSectionReadingPlan;
